export type IGetPeriod = () => number;
export type ICommand = () => unknown;

export class BufferedCommand {
    bufferingPeriod: IGetPeriod;
    heartbeatPeriod: IGetPeriod;
    execute: ICommand;
    bufferingTimer: CommandTimer;
    heartbeatTimer: CommandTimer;
    running: boolean = false;

    constructor(bufferingPeriod: IGetPeriod, heartbeatPeriod: IGetPeriod, execute: ICommand) {

        this.bufferingPeriod = bufferingPeriod;
        this.heartbeatPeriod = heartbeatPeriod;

        this.bufferingTimer = new CommandTimer(() => {
            this.heartbeatTimer.cancel();
            this.doExecute();
        });
        this.heartbeatTimer = new CommandTimer(() => {
            this.bufferingTimer.cancel();
            this.doExecute();
        });
        this.execute = execute;
    }

    doExecute() {
        this.execute();
        this.running = false;
    }

    destroy() {
        if (this.running) {
            if (this.bufferingTimer !== null) {
                this.bufferingTimer.cancel();
            }
            if (this.heartbeatTimer !== null) {
                this.heartbeatTimer.cancel();
            }
        }
    }

    force() {
        this.bufferingTimer.cancel();
        this.heartbeatTimer.cancel();
        this.doExecute();
    }

    invoke() {
        if (this.running) {
            this.heartbeatTimer.cancel();
        } else {
            this.running = true;
            this.bufferingTimer.schedule(this.bufferingPeriod());
        }

        this.heartbeatTimer.schedule(this.heartbeatPeriod());
    }
}

export class CommandTimer {
    callback: ICommand;
    timer: ReturnType<typeof setTimeout> | null = null;

    constructor(callback: ICommand) {
        this.callback = callback;
    }

    schedule(timeout: number) {
        this.cancel();
        this.timer = setTimeout(this.callback, timeout);
    }

    cancel() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
}
